@if (!isDialog) {
  <app-menu-common url="sales"></app-menu-common>
}

<div class="partners-page">

  <!-- ══════════════════════════════════════════════════════════════════════════
  SÉLECTEUR — une seule barre : identité, les filtres, les actions.
  Remplace le bandeau « pageheader » de trois colonnes (~205 px, mat-form-field,
  mat-checkbox et sa rangée de boutons centrés) par ~66 px.
  Pas de compteur ici : il est porté par la barre au-dessus du tableau.
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="toolbar-card">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">groups</mat-icon>
      <span>Tiers</span>
    </div>

    <div class="filters-inline">

      <div class="filter-item name-filter">
        <label class="filter-label" for="ptn-flt-name">Nom&nbsp;/&nbsp;Prénom</label>
        <div class="input-wrap">
          <!-- Une saisie numérique strictement positive part sur la branche NIR (voir onSearch).
          La touche Entrée est écoutée ICI et nulle part ailleurs : sur la barre entière, elle
          remontait aussi depuis les <button>, où Entrée déclenche le clic par défaut — presser
          Entrée sur « Effacer » lançait donc une recherche AVANT de vider les filtres, et la
          réponse repeuplait la liste sous une barre remise à zéro. -->
          <input id="ptn-flt-name" #searchNameInput class="custom-input" type="text" autocomplete="off"
            placeholder="Nom, prénom ou NIR" [(ngModel)]="searchname" (keydown)="onKeydown($event)">
          @if (searchname) {
            <button type="button" class="input-clear" aria-label="Effacer le nom"
              title="Effacer le nom" (click)="clearName()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>

      <div class="filter-item">
        <label class="filter-label">Rôles</label>
        <div class="role-toggles">
          @for (r of ROLE_ORDER; track r) {
            <button type="button" [class]="'role-toggle r' + r" [class.on]="roles.includes(r)"
              [attr.aria-pressed]="roles.includes(r)" [title]="roleLabel(r)"
              (click)="onRoleToggle(r, !roles.includes(r))">{{ roleLabel(r) }}</button>
          }
        </div>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="ptn-flt-act">Activité</label>
        <select id="ptn-flt-act" class="custom-select act-select" [(ngModel)]="searchact" (change)="onSearch()">
          @for (a of activities; track a.id) {
            <option [value]="a.id">{{ a.name }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <!-- Identifiants préfixés `ptn-` : en fenêtre, le composant est ajouté en FIN de
        <body> (cdk-overlay-container) au-dessus de pages qui portent déjà #flt-store et
        #flt-act — quotations et rentals, celles-là mêmes qui hébergent app-search-partner.
        `<label for>` désigne le PREMIER élément de l'arbre portant l'id : le libellé de la
        fenêtre pilotait le select de la page située dessous. -->
        <label class="filter-label" for="ptn-flt-store">Site</label>
        <select id="ptn-flt-store" class="custom-select store-select" [(ngModel)]="searchstore" (change)="onSearch()">
          @for (s of stores; track s.id) {
            <option [value]="s.id">{{ s.name }}</option>
          }
        </select>
      </div>

    </div>

    <div class="toolbar-actions">
      <!-- Uniquement en PAGE. En fenêtre, ce routerLink navigue la page qui est DESSOUS —
      détruisant au passage la commande en cours de saisie et le app-search-partner qui a
      ouvert la fenêtre — et la mat-dialog, qui vit dans le cdk-overlay-container, reste
      ouverte par-dessus une fiche vierge. `closeOnNavigation` ne rattrape pas : MatDialog
      n'écoute que les popstate, pas les navigations du Router. -->
      @if (!isDialog) {
        <a mat-stroked-button class="btn-inline btn-wide btn-ghost" [routerLink]="['/common/partner']"
          id="newpartnerbutton" title="Créer un nouveau tiers">
          <mat-icon>person_add</mat-icon><span class="btn-text">Nouveau tiers</span>
        </a>
      }
      <!-- En FENÊTRE seulement (la page a son lien ci-dessus) : la fiche s'ouvre PAR-DESSUS, et
      le tiers enregistré ressort par le contrat des lignes — cette fenêtre se ferme en le rendant. -->
      @if (isDialog) {
        <button mat-stroked-button class="btn-inline btn-wide btn-ghost" id="newpartnerdialogbutton"
          aria-label="Nouveau tiers" title="Créer un nouveau tiers sans quitter cette fenêtre"
          (click)="openNewPartner()">
          <mat-icon>person_add</mat-icon><span class="btn-text">Nouveau tiers</span>
        </button>
      }
      <button mat-flat-button color="primary" class="btn-inline" aria-label="Rechercher"
        title="Lancer la recherche" (click)="onSearch()">
        <mat-icon [class.spinning]="is_loading">{{ is_loading ? 'refresh' : 'search' }}</mat-icon>
      </button>
      <button mat-flat-button class="error btn-inline" aria-label="Effacer"
        title="Réinitialiser les filtres" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
      @if (isDialog) {
        <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Fermer"
          title="Fermer sans choisir de tiers" [mat-dialog-close]="">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
  CONTENU : la liste occupe toute la largeur (pas d'aperçu latéral ici — il n'existe
  pas d'équivalent d'app-quotationdetails pour un tiers).
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="content-row">

    <div class="table-card">

      <!-- Barre de la carte : identité, compteur, répartition par rôle, alerte de troncature -->
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>list_alt</mat-icon>
          <span>Liste des tiers</span>
          <span class="badge-count">{{ rows.length }}</span>
        </div>

        <div class="kpi-inline">
          @if (isTruncated) {
            <div class="kpi-chip warn"
              matTooltip="Le serveur s'arrête après la 201e ligne : il existe probablement d'autres tiers, et rien ne dit lesquels — la requête n'a pas d'ordre défini.&#10;Le tri par entête porte donc sur les lignes AFFICHÉES, pas sur la base : affinez le nom, l'activité ou le site."
              matTooltipClass="tooltip-multiline">
              <mat-icon class="kpi-icon">warning</mat-icon>
              <span class="kpi-label">Liste tronquée</span>
              <span class="kpi-value">≥&nbsp;{{ SERVER_LIMIT }}</span>
            </div>
          }
          @for (r of ROLE_ORDER; track r) {
            <div [class]="'kpi-chip role r' + r"
              [matTooltip]="'Tiers portant le rôle « ' + roleLabel(r) + ' » parmi les ' + rows.length + ' affichés'">
              <span class="kpi-label">{{ roleLabel(r) }}</span>
              <span class="kpi-value">{{ roleCounts[r] }}</span>
            </div>
          }
        </div>
      </div>

      <div class="table-partners">

        <!-- Entête collante — même expression de bascule de tri que le sélecteur de commandes -->
        <div class="partner-line entete">
          @for (col of displayedColumnsInfo; track col[0]) {
            <div [class]="'cell ' + col[0] + '-cell ' + col[2]"
              [matTooltip]="colSortHint(col[0])" matTooltipClass="tooltip-multiline"
              (click)="sortRows((col[3] === undefined ? true : (col[3] === true ? false : true)), col[0])"
              style="cursor: pointer;">
              <span class="sort-arrow">{{col[3] === undefined ? '' : (col[3] === true ? '&#8593;' : '&#8595;')}}</span> {{ col[1] }}
            </div>
          }
        </div>

        @if (rows.length > 0) {
          <!-- Body — en mode page c'est un VRAI lien : ctrl-clic ouvre la fiche dans un
          onglet, et la barre d'état montre l'URL. En mode dialogue la ligne n'a pas de
          routerLink (donc pas d'href, donc pas de tabulation native) : on lui rend un
          tabindex et la touche Entrée, et le clic rend le tiers à l'appelant. -->
          @for (r of rows; track r.id; let isEven = $even) {
            <a class="partner-line unstyled-link" [class.even]="isEven"
              [routerLink]="isDialog ? null : ['/common/partner', r.id]"
              [attr.tabindex]="isDialog ? 0 : null" [attr.role]="isDialog ? 'button' : null"
              (click)="onClickRow(r, $event)" (keydown.enter)="onRowEnter(r)">
              @for (col of displayedColumnsInfo; track col[0]) {
                <div [class]="'cell ' + col[0] + '-cell ' + col[2]">
                  @if (col[0] === 'id') {
                    {{ r.id }}
                  } @else if (col[0] === 'store') {
                    {{ r.store }}
                  } @else if (col[0] === 'roles') {
                    @for (pill of r.roles; track pill.id) {
                      <span [class]="'role-pill r' + pill.id" [class.unknown]="!pill.known"
                        [title]="pill.label">{{ pill.short }}</span>
                    }
                  } @else if (col[0] === 'activity') {
                    <span [title]="r.activity">{{ r.activity }}</span>
                  } @else if (col[0] === 'name') {
                    @if (r.civility) { <span class="civ">{{ r.civility }}</span> }<span [title]="r.name">{{ r.name }}</span>
                  } @else if (col[0] === 'firstname') {
                    <span [title]="r.firstname">{{ r.firstname }}</span>
                  } @else if (col[0] === 'address') {
                    <span [title]="r.address">{{ r.address }}</span>
                  } @else if (col[0] === 'zip') {
                    {{ r.zip }}
                  } @else if (col[0] === 'city') {
                    <span [title]="r.city">{{ r.city }}</span>@if (r.addrCount > 1) { <span class="addr-more" [title]="r.addrHint">+{{ r.addrCount - 1 }}</span> }
                  } @else if (col[0] === 'tel1') {
                    {{ r.tel1 }}
                  } @else if (col[0] === 'email') {
                    <span [title]="r.email">{{ r.email }}</span>
                  }
                </div>
              }
            </a>
          }
        } @else if (is_loading) {
          <div class="loading-partners">
            <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
            <span>Recherche des tiers…</span>
          </div>
        } @else if (hasSearched) {
          <div class="empty-partners">
            <mat-icon class="empty-icon">person_search</mat-icon>
            <div class="empty-title">Aucun tiers</div>
            <div class="empty-subtitle">Aucun tiers ne correspond aux critères courants&nbsp;: élargissez le nom, les rôles, l'activité ou le site.</div>
            <button mat-stroked-button color="primary" class="action-btn" (click)="onCancel()">
              <mat-icon>clear</mat-icon>
              Réinitialiser les filtres
            </button>
          </div>
        } @else {
          <div class="empty-partners">
            <mat-icon class="empty-icon">search</mat-icon>
            <div class="empty-title">Recherche de tiers</div>
            <div class="empty-subtitle">Saisissez un nom, un prénom ou un NIR — ou choisissez une activité ou un site — puis lancez la recherche. Les rôles seuls ne suffisent pas&nbsp;: le serveur exige au moins un de ces trois critères.</div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
